import { render, staticRenderFns } from "./GameResult.vue?vue&type=template&id=ec3faa2e&scoped=true&"
import script from "./GameResult.vue?vue&type=script&lang=js&"
export * from "./GameResult.vue?vue&type=script&lang=js&"
import style0 from "./GameResult.vue?vue&type=style&index=0&id=ec3faa2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec3faa2e",
  null
  
)

export default component.exports